// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"ea466fd1","222":"c779cfe7","255":"2d08772b","425":"77d9211b","679":"37d42e52","907":"7c9c7175"}[chunkId] + ".chunk.css";
};